
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"6.709","height":"16","viewBox":"0 0 6.709 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 151310","d":"M5.605 0h1.1L1.1 16H0z","fill":"#bac1cc"}})])
          )
        }
      }
    